import { REPORTS_CLIENT } from "../clients/reports.client";

export type ResourceType = "report" | "folder";

export interface FavoriteToggleResponse {
    resource_type: ResourceType;
    resource_id: string;
    is_favorited: boolean;
}

export const toggleFavorite = async (
    resource_type: ResourceType,
    resource_id: string,
    is_favorited: boolean
): Promise<FavoriteToggleResponse> => {
    try {
        if (is_favorited) {
            const response = await REPORTS_CLIENT.delete<FavoriteToggleResponse>(
                `/favorites/${resource_type}/${resource_id}`
            );
            return response.data;
        } else {
            const response = await REPORTS_CLIENT.post<FavoriteToggleResponse>(
                `/favorites/${resource_type}/${resource_id}`,
                {}
            );
            return response.data;
        }
    } catch (error) {
        console.error("Error toggling favorite:", error);
        throw error;
    }
};
